import React, { useContext } from 'react';
import * as d3 from 'd3';

// Component that returns which icon to use depending on the type of alert
import IconSelector from './AlertIcons';
import { ColorContext } from 'App';

// Main function
export default function RenderAlerts({ arrayOfData, setSelectedAlert }) {
  function convertDate(dateStr) {
    const parts = dateStr.split(/[\s/:]/);
    const formattedDateStr = `${parts[2]}-${parts[0]}-${parts[1]}T${parts[3]}:${parts[4]}:00.000Z`;
    return formattedDateStr;
  }
  const colorScale = d3
    .scaleLinear()
    .domain([0, 66, 100]) // input
    .range(['#CD2C2E', '#EE8918', '#34A100']);

  const theme = useContext(ColorContext);

  if (!arrayOfData) {
    return <div className="d-flex justify-content-center align-items-center mt-1">Loading...</div>;
  }

  if (arrayOfData.length === 0) {
    return <div className="d-flex align-items-center mt-1">No alerts to show, you're safe!</div>;
  }

  return (
    <div className="d-flex flex-column max-h-75 overflow-y-auto">
      {arrayOfData.map((event, index) => {
        return (
          <div
            className="d-flex flex-column mb-1 p-1 cursor-pointer"
            key={index}
            onClick={() => setSelectedAlert(event)}
          >
            <div className="d-flex align-items-end justify-content-end">
              <p className="d-flex align-items-end mb-1 w-fit">
                <em>
                  from {event.sender},{' at '}
                  {new Date(convertDate(event.startTime)).toLocaleString([], {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                  })}
                </em>
              </p>
            </div>
            <div className="d-flex flex-row h-100">
              <div
                className="d-flex mx-3 p-2 flex-shrink-1 align-items-center justify-content-center rounded"
                style={{ backgroundColor: colorScale(event.severity) }}
              >
                {<IconSelector type={event.type} />}
              </div>

              <div
                className="d-flex flex-row flex-grow-1 justify-content-between align-content-center rounded"
                style={{ backgroundColor: colorScale(event.severity) }}
              >
                <p className="overflow-hidden mx-auto p-1 flex-grow-1 h-fit w-100 fs-5 text-white">
                  {event.headline}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
